module.exports = __webpack_public_path__ + "media/images/bg-footer-55a06c3068c3fbc3bac1e97bfa92e275.jpg";